<div class="container">
    <h3>Edit Profile</h3>
</div>

<div class="container">
    <!-- <div class="col-lg-3 col-md-3 col-sm-4 col-xs-12">
        <span class="user-icon"><i class="bi bi-person"></i></span>
    </div> -->
    <div class="col-lg-9 col-md-9 col-sm-8 col-xs-12">
        <table class="table">
            <tbody [formGroup]="memberForm">
                <!-- <tr>
                    <td>Register Date</td>
                    <td>:</td>
                    <td>23/05/2021</td>
                </tr> -->
                <tr>
                    <td>First Name</td>
                    <td>:</td>
                    <td><input type="text" name="firstName" formControlName="firstName">
                        <div
                            *ngIf="memberForm.get('firstName').hasError('required') && memberForm.get('firstName').touched">
                            <small class="error">Firstname should not be empty</small>
                        </div>
                        <div
                            *ngIf="memberForm.get('firstName').hasError('minlength')&& memberForm.get('firstName').touched">
                            <small class="error">Firstname should contain minimum 3 characters</small>
                        </div>
                        <div
                            *ngIf="memberForm.get('firstName').hasError('maxlength')&& memberForm.get('firstName').touched">
                            <small class="error">Firstname should contain maximum 35 characters</small>
                        </div>
                        <div
                            *ngIf="memberForm.get('firstName').hasError('pattern')&& memberForm.get('firstName').touched">
                            <small class="error">Please enter only alphabets</small>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>Last Name</td>
                    <td>:</td>
                    <td><input type="text" name="lastName" formControlName="lastName">
                        <div
                            *ngIf="memberForm.get('lastName').hasError('required') && memberForm.get('lastName').touched">
                            <small class="error">Lastname should not be empty</small>
                        </div>
                        <div
                            *ngIf="memberForm.get('lastName').hasError('minlength')&& memberForm.get('lastName').touched">
                            <small class="error">Lastname should contain minimum 3 characters</small>
                        </div>
                        <div
                            *ngIf="memberForm.get('lastName').hasError('maxlength')&& memberForm.get('lastName').touched">
                            <small class="error">Lastname should contain maximum 35 characters</small>
                        </div>
                        <div
                            *ngIf="memberForm.get('lastName').hasError('pattern')&& memberForm.get('lastName').touched">
                            <small class="error">Please enter only alphabets</small>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>Gender</td>
                    <td>:</td>
                    <td><select name="Gender" formControlName="genderId" class="gender">
                            <option value="null" >select</option>
                            <ng-container *ngFor="let gender of gender">
                                <option value="{{gender?.genderId}}">{{gender?.genderName}}</option>
                            </ng-container>
                        </select>
                        <div
                            *ngIf="memberForm.get('genderId').hasError('required')&& memberForm.get('genderId').touched">
                            <small class="error">Please select gender</small>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>D.O.B</td>
                    <td>:</td>
                    <td><input type="date" id="myDate" max="{{maxdate| date:'yyyy-MM-dd'}}" formControlName="dob">
                        <div *ngIf="memberForm.get('dob').hasError('required')&& memberForm.get('dob').touched">
                            <small class="error">Please enter the date of birth</small>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>Email </td>
                    <td>:</td>
                    <td><input type="email" name="email" [value]="memberForm.get('email').value"  disabled></td>
                </tr>
                <tr>
                    <td>Phone Number</td>
                    <td>:</td>
                    <td><input type="text" formControlName="phoneNumber">
                        <div
                            *ngIf="memberForm.get('phoneNumber').hasError('required')&& memberForm.get('phoneNumber').touched">
                            <small class="error">Please enter phone number</small>
                        </div>
                        <div
                            *ngIf="memberForm.get('phoneNumber').hasError('pattern')&& memberForm.get('phoneNumber').touched;else test">
                            <small class="error">Please enter in digits</small>
                        </div>
                        <ng-template #test>
                            <div
                                *ngIf="memberForm.get('phoneNumber').hasError('minlength')&& memberForm.get('phoneNumber').touched">
                                <small class="error">Please enter minimum 10 digits</small>
                            </div>
                            <div
                                *ngIf="memberForm.get('phoneNumber').hasError('maxlength')&& memberForm.get('phoneNumber').touched">
                                <small class="error">Please enter maximum 10 digits</small>
                            </div>
                        </ng-template>
                    </td>
                </tr>
                <!-- <tr>
                    <td>Address</td>
                        <td>:</td>
                        <td><textarea rows="3" cols="50" formControlName="address">
                        </textarea>
                        <div
                        *ngIf="memberForm.get('address').hasError('required')&& memberForm.get('address').touched">
                        <small class="error">Please enter address</small>
                    </div>
                    </td>
                </tr> -->
            </tbody>
        </table>
    </div>
</div>
<div class="container buttons">
    <button type="button" class="bb" (click)="editProfile()">Save</button>
    <button type="button" class="bb2" [routerLink]="['/products']">Cancel</button>
</div>


<ng-template #msg>
    <!-- Modal Header -->
    <div class="modal-header">
      <h4 class="modal-title">Message</h4>
      <button type="button" class="closeModal" data-dismiss="modal" (click)="modalClose()"><i class="bi bi-x-circle"></i></button>
    </div>
    <!-- Modal body -->
    <div class="modal-body">
      <p class="text-center">{{modalService.config.initialState.message}}</p>
    </div>
    <!-- Modal footer -->
    <div class="modal-footer">
      <!-- <button type="button" class="btn btn-danger" (click)="modalClose()">CANCEL</button> -->
      <button type="button" class="btn-blue" (click)="modalClose()">OK</button>
    </div>
  </ng-template>

